<template>
    <div>
        <div class="banner inner">
            <img v-if="$store.state.user.banner.banner2" style="width:100%;" :src="$store.state.user.banner.banner2" alt="banner">
        </div>
        <div class="about_us">
            <div class="inner">
                <app-synopsis-title class="app_title">关于我们</app-synopsis-title>
                <p class="about_item" v-html="$store.state.user.aboutUs"></p>
            </div>
        </div>
        <div class="culture">
            <div class="inner">
                <app-synopsis-title class="app_title">企业文化</app-synopsis-title>
                <div class="culture_content">
                    <div class="culture_item" v-for="(item,index) in cultureList" :key="index">
                        <div class="icon_box" :style="{backgroundImage:`url('${getImage(item.ico)}')`}"></div>
                        <div class="title">{{item.title}}</div>
                        <div>{{item.subTitle}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="history">
            <div class="inner">
                <app-synopsis-title class="app_title">发展历程</app-synopsis-title>
                <div class="history_content">
                    <div class="history_line">
                        <div class="box">
                            <div v-for="(item,index) in historyList" :key="index" :class="['item',historyActive==index?'historyActive':'']" ref="historyItem">
                                <div class="year">{{item.year}}</div>
                                <img src="~@/assets/images/time.png" alt="">
                            </div>
                            <img class="img_active" :style="{left:imgActivePosition+'px',transition: historyActive==0?'':'all .3s'}" src="~@/assets/images/active_time.png" alt="">
                        </div>
                    </div>
                    <div class="distory_item">
                        <div class="swiper" ref="swiper">
                            <div class="swiper_controller" :style="{width:swiperList.length*100+'%',transform:`translateX(${swiperTranslate}px)`,transition:swiperActive==0?'':'all .3s'}">
                                <div v-for="(item,index) in swiperList" :key="index" :style="{width:swiperItemWidth}" class="swiper_item">
                                    <img :src="getImage(item.ico,'.jpg')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="environment">
            <div class="inner">
                <app-synopsis-title class="app_title">办公环境</app-synopsis-title>
                <div class="environment_content">
                    <div v-for="i in 4" :key="i">
                        <img :src="getImage(`00${i}`)" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="cooperation">
            <div class="inner">
                <app-synopsis-title class="app_title">部分合作院校</app-synopsis-title>
                <img src="~@/assets/images/yuanxiao.png" alt="">
            </div>
        </div>
        <div class="cooperation">
            <div class="inner">
                <app-synopsis-title class="app_title">生态合作伙伴</app-synopsis-title>
                <img src="~@/assets/images/shengtai.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import AppSynopsisTitle from '@/components/AppSynopsisTitle'
export default {
    name:"About",
    components:{
        AppSynopsisTitle
    },
    data(){
        return {
            cultureList:[
                {
                    title:'使命',
                    subTitle:'用信息技术推进教育智慧化',
                    ico:1
                },{
                    title:'愿景',
                    subTitle:'打造教育行业的知名品牌',
                    ico:2
                },{
                    title:'文化',
                    subTitle:'诚信 团结 创新 学习 共享',
                    ico:3
                },{
                    title:'理念',
                    subTitle:'专业专注 追求卓越',
                    ico:4
                },
            ],
            historyList:[
                {
                    year:2011,
                    ico:'2011'
                },{
                    year:2013,
                    ico:'2013'
                },{
                    year:2016,
                    ico:'2016'
                },{
                    year:2020,
                    ico:'2020'
                },{
                    year:2020,
                    ico:'2020.2'
                },{
                    year:2021,
                    ico:'2021'
                },
            ],
            historyActive:0,
            imgActivePosition:0,
            timer:null,
            swiperList:[],
            swiperItemWidth:'100%',
            swiperActive:0,
            swiperTranslate:0
        }
    },
    created(){
        if(this.historyList.length>0){
            this.swiperList = JSON.parse(JSON.stringify(this.historyList))
            this.swiperList.push(this.historyList[0])
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.imgActivePosition = this.getActivePosition()
            this.swiperItemWidth = this.$refs.swiper.offsetWidth+'px'
            clearInterval(this.timer)
            this.timer = setInterval(()=>{
                console.log(123)
                this.historyActive++
                this.swiperActive++
                if(this.historyActive === this.historyList.length) this.historyActive = 0
                
                this.imgActivePosition = this.getActivePosition()
                this.swiperTranslate = -this.swiperActive*this.$refs.swiper.offsetWidth
                setTimeout(()=>{
                    if(this.swiperActive === this.swiperList.length-1){
                        this.swiperActive = 0
                        this.swiperTranslate = 0
                    }
                },300)
            },5000)
        })
        
    },
    destroyed(){
        clearInterval(this.timer)
    },
    methods:{
        getImage(name,type=".png"){
            return require('../assets/images/'+name+type)
        },
        getActivePosition(){
            var Hwidth = this.$refs.historyItem[this.historyActive].offsetWidth
            var Hleft = this.$refs.historyItem[this.historyActive].offsetLeft
            return Hwidth/2 + Hleft
        }
    }
}
</script>
<style lang="scss" scoped>
.about_us,.culture,.history,.cooperation,.environment{
    padding: 100px 0;
    background: #fff;
    .app_title{
        margin-bottom: 100px;
    }
}
.about_us{
    .about_item{
        text-indent: 2em;
        font-size: 16px;
        font-weight: 800;
        color: #333333;
        line-height: 2;
    }
}
.culture{
    .culture_content{
        display: flex;
        justify-content: space-between;
        text-align: center;
    }
    .culture_item{
        width: 25%;
        font-size: 16px;
        font-weight: 800;
        color: #555555;
        .icon_box{
            margin: auto;
            height: 36px;
            width: 36px;
            background-repeat: no-repeat;
            background-position: center center;
        }
        .title{
            font-size: 20px;
            color: #333333;
            margin:30px 0 19px;
        }
    }
}
.history{
    .inner{
        width: 1000px;
        margin: auto;
    }
    .history_content{
        padding-top: 47px;
    }
    .history_line{
        height: 2px;
        background: linear-gradient(90deg, #FFFFFF 0%, #2089FF 100%);
        position: relative;
        
        .box{
            display: flex;
            justify-content: space-between;
            padding: 0 32px;
            position: absolute;
            width: 100%;
            left: 0;
            top: -8px;
            .item{
                position: relative;
                width: 56px;
                img{
                    margin: auto;
                }
            }
            .year{
                position: absolute;
                top: -45px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 18px;
                font-weight: 800;
                color: #333333;
                line-height: 1;
            }
            .img_active{
                position: absolute;
                left: 0;
                top: 50%;
                transform: translate(-50%,-50%);
            }
        }
        
    }
    .distory_item{
        margin-top: 20px;
    }
    .swiper{
        overflow: hidden;
    }
    .swiper_controller{
        display: flex;
    }
    .swiper_item{
        width: 100%;
        img{
            width: 100%;
        }
    }
}
.environment_content{
    display: flex;
    justify-content: space-between;
}
</style>